const routes = [
  {
    path: '/elePatrol-patrolplan', //电子巡更主页面
    name: 'patrolPlan',
    component: () => import('@src/modules/electronicPatrol/view/patrolPlanNew'),
    meta: {
      requireAuth: true
      // routerAlive: true
    }
  },
  {
    path: '/elePatrol-points', //巡更点
    name: 'points',
    component: () => import('@src/modules/electronicPatrol/view/points'),
    meta: {
      requireAuth: true
      // routerAlive: true
    }
  }
]

export default routes
